import React from 'react';
import { makeStyles, LinearProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        border: '1px solid #E8EAF4',
        borderRadius: '1rem',
        padding: '2rem',
    },
    icon: {
        backgroundColor: theme.palette.primary.main,
        borderRadius: '0.5rem',
        padding: '0.25rem',
        display: 'flex',
        marginBottom: '24px',
    },
    title: {
        paddingLeft: '1.5rem',
    },
    titleWrapper: {
        display: 'flex',
    },
    loaderWrapper: {
        marginTop: '1',
    },
}));

export interface ILinearLoader {
    icon?: React.ReactNode;
    title: string;
}

const LinearLoader = (props: ILinearLoader) => {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <div className={classes.titleWrapper}>
                {props.icon && <span className={classes.icon}>{props.icon}</span>}
                <span className={classes.title}>{props.title}</span>
            </div>

            <div className={classes.loaderWrapper}>
                <LinearProgress />
            </div>
        </div>
    );
};

export default LinearLoader;
